<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title"><strong>{{title}}</strong></h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- Code Combinations - Display combination key info -->
  <div style="margin-left:30px; margin-right:30px; margin-bottom: 20px;">
    @if (rowData && rowData.LEID) {
<div class="code-combo-box-key">
      <span class="pull-left"><i class="fa fa-shield fa-lg"></i></span>
      <span><b>Key: </b>{{rowData.LEID}} - {{rowData.CDR_NO || rowData.MARS}} - {{rowData.REPORTING_PERIOD}} - {{rowData.ME_CODE}} - {{rowData.LEDGER}} - {{rowData.CURR}} - {{rowData.CHART_CODE}}</span>
    </div>
}
    <div id="recurring-ep-code-combinations" style="display: none;"></div>
  </div>
  
  <!-- Form START -->
  @if (showEPForm) {
<div>
    <form name="recurringEPadjsForm" id="recurringEPadjsForm" novalidate autocomplete="off">
      
      <!-- Add New Adjustment Template -->
      @if (editLoadType==='L') {
<div>
        <div>
          <div class="col-md-12">
            <div class="form-horizontal">
              
              <!-- Tax Adj Description -->
              <div class="form-group">
                <label for="adj_desc" class="col-sm-3 control-label">Tax Adj Description:</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" name="adj_desc" id="adj_desc" 
                         [(ngModel)]="parentObject.ADJ_DESC" placeholder="" required>
                  @if (formErrors.adj_desc) {
<span class="form-error-container">
                    Tax Adj Description is required.
                  </span>
}
                </div>
              </div>
              
              <!-- Income Statement Account -->
              <div class="form-group">
                <label for="parent_account" class="col-md-3 control-label">Income Statement Account:</label>
                <div class="col-md-3">
                  <div class="input-group" style="position: relative;">
                    <input required type="text"
                           name="account"
                           placeholder="begin typing to select account (min 3 chars)"
                           [(ngModel)]="parentAcct"
                           (input)="onParentAccountInput(parentAcct)"
                           class="form-control input-sm"
                           autocomplete="off">
                    <span class="input-group-addon">
                      @if (!loadingParentAccounts) {
<i class="fa fa-search"></i>
}
                      @if (loadingParentAccounts) {
<i class="fa fa-spinner fa-pulse"></i>
}
                    </span>
                    
                    <!-- Search Results Dropdown -->
                    @if (showParentResults) {
<div class="account-search-results">
                      @for (account of parentAccountResults; track $index) {
<div 
                           class="search-result-item"
                           (click)="selectParentAccount(account)">
                        {{account.ACCT_DD_DISPLAY}}
                      </div>
}
                      @if (parentAccountResults.length === 0) {
<div class="search-result-item">
                        No results found
                      </div>
}
                    </div>
}
                  </div>
                  @if (parentObject.IS_ACCT_EDITABLE === 'N') {
<div>
                    <input readonly type="text" name="account" class="form-control input-sm" 
                           [value]="parentObject.ACCT_DD_DISPLAY" />
                  </div>
}
                  @if (formErrors.account) {
<span class="form-error-container">
                    Account value is required.
                  </span>
}
                </div>
              </div>
              
              <!-- Schedule Line -->
              <div class="form-group">
                @if (line_flag) {
<label for="schdhClassification" class="col-md-3 control-label">5471 Sch H Line:</label>
}
                @if (!line_flag) {
<label for="schdhClassification" class="col-md-3 control-label">8865 Sch M1 Line:</label>
}
                <div class="col-md-3">
                  <select (change)="changeSchd()" id="schdhClassification" class="form-control" 
                          name="schdhClassification" [(ngModel)]="getLineDetails.selected" 
                          [disabled]="isSchdHDisabled">
                    @for (s of getLineDetails.list; track $index) {
<option [ngValue]="s">{{s.DESCRIPTION}}</option>
}
                  </select>
                </div>
                
                <div class="form-group">
                  <label class="col-sm-3 control-label">Line No:</label>
                  <div class="col-sm-3">
                    <label class="control-label">{{parentObject.SCHD_H_LINE_NO}}</label>
                  </div>
                </div>
              </div>
              
              <!-- Apply Same Adjustment -->
              <div class="form-group">
                <label for="applySameAdj" class="col-sm-3 control-label">Apply the same adjustment amount for all years:</label>
                <div class="col-sm-3">
                  <input type="checkbox" name="applySameAdj" id="applySameAdj" 
                         [ngModel]="parentObject.APPLY_SAME_ADJ === 'Y'"
                         (ngModelChange)="parentObject.APPLY_SAME_ADJ = $event ? 'Y' : 'N'; checkAcct()"
                         [disabled]="!parentObject.LOCAL_ACCT_KEY">
                  @if (!parentObject.LOCAL_ACCT_KEY) {
<span style="margin-left: 10px; color: #999; font-size: 12px;">
                    (Select Income Statement Account first)
                  </span>
}
                </div>
              </div>
              
              <!-- Adjustment Amount -->
              <div class="form-group">
                <label for="adjAmount" class="col-sm-3 control-label">Adjustment Amount</label>
                <div class="col-sm-3">
                  @if (parentObject.APPLY_SAME_ADJ=='N') {
<input type="number" 
                         class="form-control text-right" name="adjAmount" id="adjAmount" 
                         [(ngModel)]="parentObject.ADJ_AMOUNT" placeholder="" readonly step="0.01">
} 
                  @if (parentObject.APPLY_SAME_ADJ=='Y') {
<input type="number" 
                         (keyup)="setAdjAmount('INCOME')" 
                         class="form-control text-right" name="adjAmount" id="adjAmount" 
                         [(ngModel)]="parentObject.ADJ_AMOUNT" placeholder="" step="0.01">
} 
                </div>
              </div>
              
              <!-- Balance Sheet Account -->
              <div class="form-group">
                <label for="offset_account" class="col-md-3 control-label">Balance Sheet Account:</label>
                <div class="col-md-3">
                  <div class="input-group" style="position: relative;">
                    <input required type="text"
                           name="offsetAccount"
                           placeholder="begin typing to select account (min 3 chars)"
                           [(ngModel)]="offset_acct"
                           (input)="onOffsetAccountInput(offset_acct)"
                           class="form-control input-sm"
                           autocomplete="off">
                    <span class="input-group-addon">
                      @if (!loadingOffsetAccounts) {
<i class="fa fa-search"></i>
}
                      @if (loadingOffsetAccounts) {
<i class="fa fa-spinner fa-pulse"></i>
}
                    </span>
                    
                    <!-- Search Results Dropdown -->
                    @if (showOffsetResults) {
<div class="account-search-results">
                      @for (account of offsetAccountResults; track $index) {
<div 
                           class="search-result-item"
                           (click)="selectOffsetAccount(account)">
                        {{account.ACCT_DD_DISPLAY}}
                      </div>
}
                      @if (offsetAccountResults.length === 0) {
<div class="search-result-item">
                        No results found
                      </div>
}
                    </div>
}
                  </div>
                  @if (formErrors.offsetAccount) {
<span class="form-error-container">
                    Account value is required.
                  </span>
}
                </div>
              </div>
              
              <!-- Balance Sheet Amount -->
              <div class="form-group">
                <label for="offset_amount" class="col-sm-3 control-label">Balance Sheet Amount</label>
                <div class="col-sm-3">
                  <input type="number" class="form-control text-right" name="offset_amount" id="offset_amount" 
                         [(ngModel)]="offsetObject.ADJ_AMT" 
                         (keyup)="setAdjAmount('BALANCE')" 
                         [disabled]="parentObject.APPLY_SAME_ADJ=='N'"
                         step="0.01">
                </div>
              </div>
              
              <!-- Begin Year -->
              <div class="form-group">
                <label for="beginYear" class="col-sm-3 control-label">Enter the Beginning Year for the Adjustment (yyyy):(has to be >= {{taxYear}})</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" maxlength="4" name="beginYear" id="beginYear" 
                         [(ngModel)]="parentObject.BEGIN_YEAR" placeholder="" required 
                         (keyup)="setAdjyear('BEGINYEAR')">
                  @if (formErrors.beginYear) {
<span class="form-error-container">
                    {{formErrors.beginYear}}
                  </span>
}
                </div>
              </div>
              
              <!-- End Year -->
              <div class="form-group">
                <label for="endYear" class="col-sm-3 control-label">Enter the Ending Year for the Adjustment (yyyy):</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" maxlength="4" name="endYear" id="endYear" 
                         [(ngModel)]="parentObject.END_YEAR" placeholder="" required 
                         (keyup)="setAdjyear('ENDYEAR')">
                  @if (formErrors.endYear) {
<span class="form-error-container">
                    {{formErrors.endYear}}
                  </span>
}
                </div>
              </div>
              
              <!-- Supplemental Information -->
              <div class="form-group">
                <label for="supplInfo" class="col-sm-3 control-label">Supplemental Information:</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" name="supplInfo" id="supplInfo" 
                         [(ngModel)]="parentObject.SUPPL_INFO" placeholder="">
                </div>
                
                <label for="addAttachment" class="col-sm-3 control-label">Add Attachment</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" name="addAttachment" id="addAttachment" 
                         [(ngModel)]="addAttachment" placeholder="">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Adjust Amounts By Year -->
        @if (showAdjamtByYear) {
<div style="margin-left:10px;"> 
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <table class="table table-nonfluid table-hover table-bordered table-striped table-condensed custom-table">
              <thead>
                <tr>
                  @for (yearAdjHeader of total_loops_header_arr; track $index) {
<th style="text-align: center;">
                    {{yearAdjHeader.HEADER_NAME}}
                  </th>
}
                </tr>
              </thead>
              <tbody>
                @for (yearAdj of total_loops_arr; track $index; let i = $index) {
<tr> 
                  @for (yearAdjHeader of total_loops_header_arr; track $index) {
<td>
                    @if (yearAdjHeader.HEADER_INDEX=='YEAR') {
<span>{{yearAdj[yearAdjHeader.HEADER_INDEX]}}</span>
}
                    @if (yearAdjHeader.HEADER_INDEX=='CUR_ADJ_AMT') {
<input 
                           type="number" class="form-control input-sm numText" 
                           [(ngModel)]="yearAdj[yearAdjHeader.HEADER_INDEX]" 
                           [name]="'cur_adj_amt_' + i"
                           [disabled]="parentObject.APPLY_SAME_ADJ=='Y'"
                           step="0.01">
}
                    @if (yearAdjHeader.HEADER_INDEX !='YEAR' && yearAdjHeader.HEADER_INDEX !='CUR_ADJ_AMT') {
<input 
                           type="number" class="form-control input-sm numText" 
                           [(ngModel)]="yearAdj[yearAdjHeader.HEADER_INDEX]" 
                           [name]="'offset_adj_amt_' + i"
                           [disabled]="parentObject.APPLY_SAME_ADJ=='Y'"
                           step="0.01">
}
                  </td>
}
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
}
      </div>
}
      <!-- END New Adjustment Template-->
      
      <!-- Edit Existing Adjustment Template -->
      @if (editLoadType==='E') {
<div>
        <div>
          <div class="col-md-12">
            <div class="form-horizontal">
              
              <!-- Income Statement Account (readonly) -->
              <div class="form-group">
                <label for="parent_account" class="col-md-3 control-label">Income Statement Account:</label>
                <div class="col-md-3">
                  <div>
                    <input readonly type="text" name="account" class="form-control input-sm" 
                           [value]="parentObject.ACCT_DD_DISPLAY" />
                  </div>
                </div>
              </div>
              
              <!-- Schedule Line -->
              <div class="form-group">
                @if (line_flag) {
<label for="schdhClassification" class="col-md-3 control-label">5471 Sch H Line:</label>
}
                @if (!line_flag) {
<label for="schdhClassification" class="col-md-3 control-label">8865 Sch M1 Line:</label>
}
                <div class="col-md-3">
                  <select (change)="changeSchd()" id="schdhClassification" class="form-control" 
                          name="schdhClassification" [(ngModel)]="getLineDetails.selected">
                    @for (s of getLineDetails.list; track $index) {
<option [ngValue]="s">{{s.DESCRIPTION}}</option>
}
                  </select>
                  @if (formErrors.schdhClassification) {
<span class="form-error-container">
                    Balance Sheet Statement Parent Account selected with 5471/8865 Line No.
                  </span>
}
                </div>
                <label class="col-sm-3 control-label">Line No:</label>
                <div class="col-sm-3">
                  <label class="control-label">{{parentObject.SCHD_H_LINE_NO}}</label>
                </div>
              </div>
              
              <!-- Tax Adj Description -->
              <div class="form-group">
                <label for="adj_desc" class="col-sm-3 control-label">Tax Adj Description:</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" name="adj_desc" id="adj_desc" 
                         [(ngModel)]="parentObject.ADJ_DESC" placeholder="" required>
                  @if (formErrors.adj_desc) {
<span class="form-error-container">
                    Adjustment Description is required.
                  </span>
}
                </div>
              </div>

              <!-- Supplemental Information -->
              <div class="form-group">
                <label for="supplInfo" class="col-sm-3 control-label">Supplemental Information:</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" name="supplInfo" id="supplInfo" 
                         [(ngModel)]="parentObject.SUPPL_INFO" placeholder="">
                </div>
              </div>
              
              <div class="form-group">
                <label for="addAttachment" class="col-sm-3 control-label">Add Attachment</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" name="addAttachment" id="addAttachment" 
                         [(ngModel)]="addAttachment" placeholder="">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Edit Adjustment Amounts -->
        <div style="margin-left:10px;"> 
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <table class="table table-nonfluid table-hover table-bordered table-striped table-condensed custom-table">
              <thead>
                <tr>
                  @for (editAdjHeader of total_loops_header_arr; track $index) {
<th style="text-align: center;">
                    {{editAdjHeader.HEADER_NAME}}
                  </th>
}
                </tr>
              </thead>
              <tbody>
                @for (editAdj of total_loops_arr; track $index; let i = $index) {
<tr> 
                  @for (editAdjHeader of total_loops_header_arr; track $index) {
<td>
                    @if (editAdjHeader.HEADER_INDEX=='YEAR') {
<span>{{editAdj.YEAR}}</span>
}
                    @if (editAdjHeader.HEADER_INDEX=='PARENT') {
<input 
                           type="number" class="form-control input-sm numText" 
                           [(ngModel)]="editAdj.CUR_ADJ_AMT"
                           [name]="'cur_adj_amt_edit_' + i"
                           step="0.01">
}
                    @if (editAdjHeader.HEADER_INDEX !='YEAR' && editAdjHeader.HEADER_INDEX !='PARENT') {
<input 
                           type="number" class="form-control input-sm numText" 
                           [(ngModel)]="editAdj[editAdjHeader.HEADER_INDEX]"
                           [name]="'offset_adj_amt_edit_' + i"
                           step="0.01">
}
                  </td>
}
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}
    </form>
  </div>
}
</div>
<!-- End Modal Body -->

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>

<!-- Existing Recurring EP Adjustments -->
@if (showEPForm) {
<div style="margin-left:30px; margin-right:30px" [hidden]="minimise">
  
  <div class="table-responsive">
    <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table">
      <thead>
        <tr>
          <th style="text-align: center;">Edit</th>
          <th style="text-align: center;">Delete</th>
          <th>Tax Adj Description</th>
          <th>Adjustment Type</th>
          <th>Account Details</th>
          <th>{{line_flag ? "5471 Sch H Line" : "8865 Sch M1 Line"}}</th>
          <th>Amount</th>
          <th>VFR</th>
        </tr>
      </thead>

      @if (existingLoading) {
<tbody>
        <tr>
          <td class="loading-table" colspan="9">
            <i style="margin-top:20px" class="fa fa-2x fa-spinner fa-pulse"></i>
          </td>
        </tr>
      </tbody>
}

      @if (noRecords && !existingLoading) {
<tbody>
        <tr>
          <td class="loading-table" colspan="9">
            <div style="margin-top:40px"><b>No Existing Adjustments</b></div>
          </td>
        </tr>
      </tbody>
}

      @if (!existingLoading && !noRecords) {
<tbody>
          @for (existingAdjs of existingAdjustments; track $index; let i = $index) {

            @if (existingAdjs.ROWNUMBER==1) {
<tr>
              <td align="center">
                <a href="javascript:void(0)" (click)="confirmLoadEPRecurData(i)">
                  <i class="fa fa-pencil"></i> Edit
                </a>
              </td>
              <td align="center">
                <a href="javascript:void(0)" (click)="confirmDeleteAdjs(existingAdjs)">
                  <i class="fa fa-times"></i>Delete
                </a>
              </td>
            <td>{{existingAdjs.EP_DESC}}</td>
            <td>{{existingAdjs.ADJ_TYPE}}</td>
            <td colspan="3">{{existingAdjs.BEGIN_YEAR}} - {{existingAdjs.END_YEAR}}</td>
            <td></td>
          </tr>
}
          
          @if (existingAdjs.ROWNUMBER==1) {
<tr>
            <td colspan="4">Income Statement Details</td>
            <td>{{existingAdjs.ACCT}} - {{existingAdjs.ACCT_DESC}}</td>
            <td>{{existingAdjs.LINE_NO}} - {{existingAdjs.LINE_DESC}}</td>
            <td align="right">{{existingAdjs.ADJ_AMOUNT}}</td>
            <td></td>
          </tr>
}
          
          @if (existingAdjs.ROWNUMBER==1 && existingAdjs.OFFSET_COUNT > 0) {
<tr>
            <td colspan="4">Offset Details</td>
            <td>{{existingAdjs.OFFSET_ACCT}} - {{existingAdjs.OFFSET_ACCT_DESC}}</td>
            <td>{{existingAdjs.OFFSET_LINE_NO}} - {{existingAdjs.OFFSET_LINE_DESC}}</td>
            <td align="right">{{existingAdjs.OFFSET_AMOUNT}}</td>
            <td></td>
          </tr>
}
          
          @if (existingAdjs.ROWNUMBER>1) {
<tr>
            <td colspan="4"></td>
            <td>{{existingAdjs.OFFSET_ACCT}} - {{existingAdjs.OFFSET_ACCT_DESC}}</td>
            <td>{{existingAdjs.OFFSET_LINE_NO}} - {{existingAdjs.OFFSET_LINE_DESC}}</td>
            <td align="right">{{existingAdjs.OFFSET_AMOUNT}}</td>
            <td></td>
          </tr>
}
        
}
      </tbody>
}
    </table>
  </div>
</div>
}
